import React, { useState } from "react";
import ConfirmacionErroresVentana from "../spac/Confirmacion/Detalle/ConfirmacionErroresVentana";

const BlankPage = () => {
  const [blankPageKey] = useState(localStorage.getItem('blankPageKey'));

  if (blankPageKey === "confirmacionErroresNuevaVentana") {
    return <ConfirmacionErroresVentana />;
  } else {
    return null;
  }
}

export default React.memo(BlankPage);
